export const LocalStorageConstants = {
  TEAMS: "teams",
  SOURCE_CODES: "source-codes"
};
